export default [
  'localhost:3000',
  'http://boomerang.daoapp.io/'
];



// WEBPACK FOOTER //
// ./src/config/hosts.js